import React, { useMemo } from "react";
import moment from "moment";
import { gettext } from "../../adapter";
import { signedNumberString } from "../../utils/globalUtils";
import SprayingForecastHour from "./SprayingForcastHour";
import { useSelector } from "react-redux";
import { ReactComponent as RainIcon } from "./../../images/svg/rain.svg";
import { ReactComponent as DewIcon } from "./../../images/svg/dew.svg";
import { ReactComponent as FrostIcon } from "./../../images/svg/frost.svg";
import { ReactComponent as BlockIcon } from "./../../images/svg/block.svg";
import { ReactComponent as WindIcon } from "./../../images/svg/wind.svg";
import { parseRegion } from "../../utils/weatherForecastUtils";

const SprayingForecast = () => {
  const regionState = useSelector((state) => {
    return state.weatherRegion;
  });

  const { sprayplanner, region } = useMemo(() => {
    if (!regionState.region) {
      return { ...regionState };
    } else {
      return {
        ...parseRegion(regionState.region),
      };
    }
  }, [regionState]);

  if (!sprayplanner) return null;

  var days = Object.keys(sprayplanner).reduce((result, hour) => {
    if (!result.includes(hour.substring(0, 10))) {
      result.push(hour.substring(0, 10));
    }
    return result;
  }, []);
  days = days.slice(0, 10);

  var header = days.map(function (day, i) {
    return (
      <th key={i}>
        <span>{moment(day).format("dd")}</span>
      </th>
    );
  });
  var header2 = days.map(function (day, i) {
    return (
      <th key={i}>
        <span>{day.substr(8, 2)}</span>
      </th>
    );
  });
  var hours = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
  ].map(function (hour) {
    return (
      <SprayingForecastHour key={hour} sprayingforecast={sprayplanner} days={days} hour={hour} />
    );
  });

  var timezoneOffsetBrowser = new Date().getTimezoneOffset();
  if (region.timezoneOffset !== timezoneOffsetBrowser) {
    console.warn(
      "You are watching the spray planner for a different timezone (" +
        signedNumberString(region.timezoneOffset / 60) +
        "h) then yours (" +
        signedNumberString(timezoneOffsetBrowser / 60) +
        "h)"
    );
  }

  return (
    <div className="l-full">
      <div className="panel has-object-preloader">
        <h2>
          {gettext("Spray planner")}
          <small>{region.name}</small>
        </h2>
        <div className="planner--layout">
          <div className="table-wrapper">
            <table className="planner--rotated">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  {header}
                </tr>
                <tr>
                  <th>&nbsp;</th>
                  {header2}
                </tr>
              </thead>
              <tbody>{hours}</tbody>
            </table>
          </div>
          <div className="planner--legenda--rotate">
            <ul className="legenda--rotate">
              <li>
                <BlockIcon className="icon VERY_GOOD" />
                {gettext("Very good")}
              </li>
              <li>
                <BlockIcon className="icon GOOD" />
                {gettext("Good")}
              </li>
              <li>
                <BlockIcon className="icon REASONABLE" />
                {gettext("Reasonable")}
              </li>
              <li>
                <BlockIcon className="icon BAD" />
                {gettext("Bad")}
              </li>
              <li>
                <BlockIcon className="icon VERY_BAD" />
                {gettext("Very bad")}
              </li>
            </ul>
            <br />
            <ul className="legenda--rotate">
              <li>
                <WindIcon className="icon is-dark" />
                {gettext("Wind speed")}
              </li>
              <li>
                <RainIcon className="icon is-dark" />
                {gettext("Precipitation probability")}
              </li>
              <li>
                <DewIcon className="icon is-dark" />
                {gettext("Dew")}
              </li>
              <li>
                <FrostIcon className="icon is-dark" />
                {gettext("Frost")}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SprayingForecast;
